import React from "react";
import "./CertificateCorporateList.scss";
import CertificateCorporateList from "../../features/CorporateCertificate/CertificateCorporateList/CertificateCorporateList";

const CertificateCorporateListPage = () => {
    return (
        <div className="analytics-page">
            <CertificateCorporateList />
        </div>
    );
};

export default CertificateCorporateListPage;
